import React from 'react';
import { FileIcon } from 'elements/Icon';

const TXT = () => (
  <FileIcon>
    <path d="M98,2v136H2V2H98 M100,0H0v140h100V0L100,0z"/>
    <rect x="12.486" y="103.044" width="74" height="24"/>
    <g>
      <rect x="12.75" y="24" width="74" height="4"/>
      <rect x="12.75" y="36" width="74" height="4"/>
      <rect x="12.75" y="48" width="74" height="4"/>
      <rect x="12.75" y="60" width="74" height="4"/>
      <rect x="12.75" y="72" width="74" height="4"/>
      <rect x="12.75" y="84" width="54" height="4"/>
    </g>
    <g>
      <path fill="#FFFFFF" className="text" d="M32.748,118.466h2.367v2.336h-2.367V118.466z"/>
      <path fill="#FFFFFF" className="text" d="M45.779,109.286v2.039h-3.445v9.477h-2.422v-9.477h-3.461v-2.039H45.779z"/>
      <path fill="#FFFFFF" className="text" d="M49.025,120.802h-2.797l3.703-5.867l-3.523-5.648h2.875l2.054,3.75l2.11-3.75h2.781l-3.523,5.555
        l3.742,5.961h-2.922l-2.188-3.927L49.025,120.802z"/>
      <path fill="#FFFFFF" className="text" d="M66.225,109.286v2.039H62.78v9.477h-2.422v-9.477h-3.461v-2.039H66.225z"/>
    </g>
  </FileIcon>
);

export default TXT;



// WEBPACK FOOTER //
// ./src/core/icons/components/files/TXT.jsx